const featuredCollectionSlider = new Swiper('.featured-collection-slider__slider', {
  spaceBetween: 15,
  slidesPerView: 1.15,

  navigation: {
    nextEl: '.featured-collection-slider-next',
    prevEl: '.featured-collection-slider-prev',
  },

  breakpoints: {
    769: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {
      slidesPerView: 3
    }
  }
});
